import type { TInjectScriptOptions } from './injectScript.types.ts';

export const injectScript = ({ id, src }: TInjectScriptOptions): void => {
  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement('script');

  script.async = true;
  script.id = id;
  script.src = src;
  document.head.appendChild(script);
};
